import { render, staticRenderFns } from "./KiSettings.vue?vue&type=template&id=6a936eaa"
import script from "./KiSettings.vue?vue&type=script&lang=js"
export * from "./KiSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports